import { useState } from "react";
import { useSelector } from "react-redux";

import { setTableHeight } from "../../../../functions/setTableHeight";
import { RECEIVER_REJECTED_HEADERS } from "../../utils/expenseTables.config";
import { truncateDesc } from "../../../../functions/truncateDesc";
import TableHead from "../../../../components/UI/TableUI/TableHead";
import { formatDate } from "../../../../functions/dateTime/formatDate";
import NoDataDisplay from "../../../../components/UI/NoDataDisplay";
import { VerifyExpense } from "./VerifyExpense";
import { ResendExpense } from "./ResendExpense";

export const TableView = ({ dataList, setViewDialogDetails }) => {
  const [verifyDialog, setVerifyDialog] = useState({
    isOpen: false,
    expenseId: "",
    receiver: "",
  });
  const [resendDialog, setResendDialog] = useState({
    isOpen: false,
    data: null,
  });
  const expenseData = useSelector((state) => state.data.data);
  const isDataAvailable = expenseData?.length > 0;
  return (
    <>
      <div className={`table-container ${setTableHeight(isDataAvailable)}`}>
        <table className={`table ${!isDataAvailable ? "relative" : ""}`}>
          <tbody>
            <TableHead headList={RECEIVER_REJECTED_HEADERS} />
            {isDataAvailable ? (
              <>
                {dataList.map((data, index) => {
                  return (
                    <tr className="table-row" key={data.id}>
                      <td>
                        {data.user.fullName} (U) <br></br>
                        {data.receiver && <>{data.receiver.fullName} (R)</>}
                      </td>
                      <td>{`₹${data.amount}`}</td>
                      <td>{truncateDesc(data.description)}</td>
                      <td>
                        {formatDate(data.date)}
                        {data.backDated && (
                          <span className="backDatedBtn">BD</span>
                        )}
                      </td>
                      <td>{data.category.name}</td>
                      <td>
                        <button
                          className="tableViewBtn"
                          onClick={() =>
                            setViewDialogDetails({ open: true, data: data })
                          }
                        >
                          View
                        </button>
                      </td>
                      <td>
                        <button
                          className="bg-emerald-100 hover:bg-emerald-50 text-emerald-600 transition-all px-2 py-1 rounded-md"
                          onClick={() =>
                            setVerifyDialog({
                              isOpen: true,
                              expenseId: data.id,
                              receiver: data.receiver.fullName,
                            })
                          }
                        >
                          Verify
                        </button>
                      </td>
                      <td>
                        <button
                          className="bg-gray-200 border-1 py-1 px-2 text-primary rounded"
                          onClick={() =>
                            setResendDialog({
                              isOpen: true,
                              data: {
                                id: data.id,
                                amount: data.amount,
                                receiver: data.receiver.fullName,
                                category: data.category.name,
                              },
                            })
                          }
                        >
                          Resend Money
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </>
            ) : (
              <NoDataDisplay />
            )}
          </tbody>
        </table>
      </div>
      {verifyDialog.isOpen && (
        <VerifyExpense
          expenseId={verifyDialog.expenseId}
          verifyDetails={verifyDialog}
          setVerifyDialog={setVerifyDialog}
        />
      )}
      {resendDialog.isOpen && (
        <ResendExpense
          resendDetails={resendDialog.data}
          setResendDialog={setResendDialog}
        />
      )}
    </>
  );
};
